import { Platform } from "react-native";

/**
 * Board sizes in screen pixels, shared by the live board and the report
 * mini-graph so both read the same at any zoom.
 */
export const NODE_R = 10;
/** Start and target: the biggest nodes on the board. */
export const ENDPOINT_R = 20;
/** The current word: between the endpoints and the path. */
export const CURRENT_R = 18;

/** Radius by role: start/target > current > path. */
export function nodeRadius(n: {
  endpoint: "start" | "target" | null;
  isCurrent: boolean;
}): number {
  if (n.endpoint) return ENDPOINT_R;
  return n.isCurrent ? CURRENT_R : NODE_R;
}

/** The target ring's width at the radius it was tuned for (14px). */
export const RING_WIDTH = 3;
const RING_TUNED_R = 14;
/** The target ring's width, scaled with the node (3px at 14px). */
export const ringWidth = (r: number) => (RING_WIDTH * r) / RING_TUNED_R;

export const LABEL_FONT = 15;
export const PATH_LABEL_FONT = 12;
export const PATH_LABEL_OPACITY = 0.7;
export const LABEL_WEIGHT = "600";
export const LABEL_HALO = 4;
/** System sans stack on web; native uses the platform's system sans. */
export const LABEL_FONT_FAMILY = Platform.select({
  web: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  default: undefined,
});
